export const payerType = { 1: "Sender", 2: "Recipient" };
